export default {
    login: "/api/v1/login",   //登陆
    logout: "/api/v1/logout", //退出登陆
    register:'/api/v1/users', //用户注册
    verification:'/api/v1/order/verification',  //验证码
    user_changepass: '/api/v1/changePass',  //修改密码
    user_info: '/api/v1/me',   //获取用户信息

    product:'/api/v1/purchase/product',
    check:'/api/v1/purchase/check',
    getShelfUrl:'/api/v1/shelves',
    removeShelf:'/api/v1/shelves/remove',//*******暂时保留,后面要移除
    order_list:'/api/v1/purchase/order/finish',//*******暂时保留,后面要移除
    shelf_finish:'/api/v1/purchase/shelf/finish',//*******暂时保留,后面要移除
    putOnShelf:'/api/v1/purchase/putOnShelf',//上架
    partition_list:'/api/v1/partition/list',//分区列表
    getPickList:'/api/v1/picking/list',//拣货列表
    pickUp:'/api/v1/pick/up',//拣货列表
    generatePickingList:'/api/v1/picking/generate',//生成拣货列表

    file_upload:'/api/v1/file/upload',//上传图片
    file_delete:'/api/v1/file/delete',//删除图片

    // B2B
    b2b_product:'/api/v1/b2b/product',//获取产品信息
    getB2bShelfUrl:'/api/v1/b2b/shelves',
    b2bCheck:'/api/v1/b2b/check',
    removeB2bShelf:'/api/v1/b2b/shelves/remove',

    //待审核货架
    pending_order:'/api/v1/pending/order',
    getPendingShelfUrl:'/api/v1/pending/shelves',
    pendingCreate:'/api/v1/pending',

    //作废
    cancel:'/api/v1/purchase/cancel',
    doCancel:'/api/v1/purchase/doCancel',
    getDetail:'/api/v1/purchase/orderDetail',

    //拣卡
    getAnnexList:'/api/v1/annex/getAnnexList',
    pickAnnex:'/api/v1/annex/pickAnnex',
    getAnnexUpList:'/api/v1/annex/getAnnexUpList',
    upAnnex:'/api/v1/annex/upAnnex',
    changeAnnexShelf:'/api/v1/annex/changeAnnexShelf',


    //仓库模块
    upDelivery:'/api/v1/warehouse/up_delivery',
}
